import React from 'react'
import ReactModal from 'react-modal'

// Styles
import './styles.scss'

// Icons
import IconClose from './images/iconClose'
import IconEmail from './images/iconEmail'
import IconPhone from './images/iconPhone'
import IconVk from './images/iconVk'
import IconInstagram from './images/iconInstagram'
import IconWa from './images/iconWa'
import IconTelegram from './images/iconTelegram'

export default ({
  isOpen,
  onRequestClose,
}: {
  isOpen: boolean
  onRequestClose: () => void
}) => {
  const customStyles: any = {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.4)',
    },
    content: {
      width: 565,
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      border: 'none',
      borderRadius: 50,
      padding: 0,
      zIndex: 1000,
      overflow: 'none',
    },
  }

  const {
    REACT_APP_CONTACT_EMAIL,
    REACT_APP_CONTACT_PHONE,
    REACT_APP_CONTACT_VK,
    REACT_APP_CONTACT_INSTAGRAM,
    REACT_APP_CONTACT_WA,
    REACT_APP_CONTACT_TELEGRAM,
  } = process.env

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      style={customStyles}
      ariaHideApp={false}
    >
      <div className={'feedback'}>
        <button className={'feedback__close'} onClick={onRequestClose}>
          <IconClose />
        </button>
        <span className={'feedback__title'}>Связаться с нами</span>
        <div className={'feedback__row'}>
          {REACT_APP_CONTACT_EMAIL ? (
            <a
              href={`mailto:${REACT_APP_CONTACT_EMAIL}`}
              className={'feedback__row-item'}
            >
              <IconEmail />
              {REACT_APP_CONTACT_EMAIL}
              <div />
            </a>
          ) : null}
          {REACT_APP_CONTACT_PHONE ? (
            <a
              href={`tel:${REACT_APP_CONTACT_PHONE}`}
              className={'feedback__row-item'}
            >
              <IconPhone />
              {REACT_APP_CONTACT_PHONE}
              <div />
            </a>
          ) : null}
          {REACT_APP_CONTACT_VK ? (
            <a
              href={`https://vk.com/${REACT_APP_CONTACT_VK}`}
              target={'_blank'}
              className={'feedback__row-item'}
              rel="noreferrer"
            >
              <IconVk />@{REACT_APP_CONTACT_VK}
              <div />
            </a>
          ) : null}
          {REACT_APP_CONTACT_INSTAGRAM ? (
            <a
              href={`https://instagram.com/${REACT_APP_CONTACT_INSTAGRAM}`}
              target={'_blank'}
              className={'feedback__row-item'}
              rel="noreferrer"
            >
              <IconInstagram />@{REACT_APP_CONTACT_INSTAGRAM}
              <div />
            </a>
          ) : null}
          {REACT_APP_CONTACT_WA ? (
            <a
              href={`https://wa.me/${REACT_APP_CONTACT_WA.replace(/\D+/g, '')}`}
              target={'_blank'}
              className={'feedback__row-item'}
              rel="noreferrer"
            >
              <IconWa />
              {REACT_APP_CONTACT_WA}
              <div />
            </a>
          ) : null}
          {REACT_APP_CONTACT_TELEGRAM ? (
            <a
              href={`https://t.me/${REACT_APP_CONTACT_TELEGRAM}`}
              target={'_blank'}
              className={'feedback__row-item'}
              rel="noreferrer"
            >
              <IconTelegram />@{REACT_APP_CONTACT_TELEGRAM}
              <div />
            </a>
          ) : null}
        </div>
      </div>
    </ReactModal>
  )
}
